import PropTypes from "prop-types";
import React, { Component } from "react";
import { Field, reduxForm, reset } from "redux-form";
import TextField from "@material-ui/core/TextField";

import { translator } from "../utils/i18n";
import { Trans } from "@lingui/macro";
import { Button } from "@material-ui/core";

import { PHONE_ALLOWED_COUNTRIES } from "../utils/constants";

import { parsePhoneNumberFromString } from "libphonenumber-js";

import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import metadataMobile from "libphonenumber-js/metadata.mobile.json";

const validate = values => {
  const errors = {};
  const requiredFields = ["snom", "smail", "ssujet", "smessage"];
  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = translator()._("W_CE_CHAMP_EST_OBLIGATOIRE");
    }
  });
  if (
    values.smail &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.smail)
  ) {
    errors.smail = translator()._("W_ADRESSE_E_MAIL_NON_VALIDE");
  }
  const phoneNumber = parsePhoneNumberFromString(values.rawTel || "");
  const telIsValid = phoneNumber ? phoneNumber.isValid() : false;
  if (values.rawTel && !telIsValid) {
    errors.smobile = translator()._("W_INVALID_PHONE");
  }
  if (telIsValid) {
    values.indicatif = phoneNumber.countryCallingCode;
    values.stel = phoneNumber.format("NATIONAL").replace(/ /g, "");
  }

  return errors;
};

class FormFaq extends Component {
  constructor(props) {
    super(props);

    this.state = {
      phone: ""
    };
  }

  renderTextField = ({
    label,
    input,
    meta: { touched, invalid, error },
    ...custom
  }) => (
    <TextField
      label={label}
      placeholder={label}
      error={touched && invalid}
      helperText={touched && error}
      {...input}
      {...custom}
    />
  );

  renderPhone = ({ input, meta: { error } }) => {
    return (
      <div>
        <PhoneInput
          className="intl-tel-input"
          countries={PHONE_ALLOWED_COUNTRIES}
          country={this.props.telDefault.toUpperCase()}
          defaultCountry={this.props.telDefault.toUpperCase()}
          international={false}
          onChange={rawTel => this.props.change("rawTel", rawTel)}
          limitMaxLength={true}
          metadata={metadataMobile}
          value={input.value}
          placeholder={`${translator()._(
            "FORMULAIRE_TELEPHONE"
          )} : 06 62 23 23 23`}
        />
        {error && <span className="error">{error}</span>}
      </div>
    );
  };

  renderSelectField = ({ input, meta: { touched, error }, children }) => (
    <React.Fragment>
      <select {...input}>{children}</select>
      {touched && error && <span className="error">{error}</span>}
    </React.Fragment>
  );

  renderTextArea = ({ input, meta: { touched, error, warning } }) => (
    <React.Fragment>
      <textarea {...input} placeholder={translator()._("W_MESSAGE")} rows="6" />
      {touched &&
        ((error && <span className="error">{error}</span>) ||
          (warning && <span className="error">{warning}</span>))}
    </React.Fragment>
  );

  render() {
    const { handleSubmit, pristine, submitting, message, invalid } = this.props;
    return (
      <form
        onSubmit={handleSubmit}
        className="custom-form form-contact form-subscribe"
      >
        {message && (
          <div className="confirm display-flex">
            <i className="material-icons mr-20">done</i>
            <div dangerouslySetInnerHTML={{ __html: message }} />
          </div>
        )}

        <div className="line-form mt-15 champ-select">
          <Field name="ssujet" component={this.renderSelectField}>
            <option value="">Veuillez choisir un sujet</option>
            <option value="[SUPPORT] rendez-vous">
              Demande concernant mon rendez-vous
            </option>
            <option value="[SUPPORT] compte">
              Demande concernant mon compte
            </option>
            <option value="[SUPPORT] assistance">
              Demande concernant une assistance
            </option>
            <option value="[SUPPORT] incident technique">
              Demande concernant un incident technique
            </option>
            <option value="[SUPPORT] autre sujet">
              Demande concernant un autre sujet
            </option>
          </Field>
        </div>
        <div className="line-form mt-15">
          <Field
            name="snom"
            component={this.renderTextField}
            label={translator()._("W_STEP4_FORMULAIRE_NOM")}
            variant="outlined"
            className="wrap-input-custom"
          />
        </div>
        <div className="line-form mt-20">
          <Field
            name="smail"
            component={this.renderTextField}
            label={translator()._("W_STEP4_FORMULAIRE_EMAIL")}
            variant="outlined"
            className="wrap-input-custom"
          />
        </div>
        <div className="line-form mt-20">
          <Field name="smobile" component={this.renderPhone} />
        </div>

        <div className="line-form mt-20">
          <Field name="smessage" component={this.renderTextArea} />
        </div>
        <div className="mt-20 align-right mr-20">
          <Button
            className="custom-btn"
            type="submit"
            disabled={invalid || submitting || pristine}
          >
            <Trans id="CP_SEND" />
          </Button>
        </div>
      </form>
    );
  }
}

FormFaq.propTypes = {
  change: PropTypes.func,
  handleSubmit: PropTypes.func,
  invalid: PropTypes.any,
  message: PropTypes.any,
  pristine: PropTypes.any,
  submitting: PropTypes.any,
  telDefault: PropTypes.string
};

const afterSubmit = (result, dispatch) => {
  dispatch(reset("FormFaq"));
};

export default reduxForm({
  form: "FormFaq",
  onSubmitSuccess: afterSubmit,
  validate
})(FormFaq);
